function parseHeaders(string) {
  if (!string) {
    return {};
  }
  const lines = string.trim().split(/[\r\n]+/);
  return lines.reduce((headers, line) => {
    const i = line.indexOf(":");
    const name = line.slice(0, i).trim();
    const value = line.slice(i + 1).trim();
    headers[name] = value;
    return headers;
  }, {});
}
function parseQuery(string) {
  if (!string) {
    return {};
  }
  return string.split("&").reduce((query, param) => {
    const [name, value] = param.split("=");
    if (name) {
      query[name] = decodeURIComponent(value || "");
    }
    return query;
  }, {});
}
function stringifyQuery(object, sort) {
  if (!object) {
    return "";
  }
  let names = Object.keys(object);
  if (typeof sort === "function") {
    names = names.sort(sort);
  } else if (sort) {
    names = names.sort();
  }
  return names.map((name) => {
    const value = encodeURIComponent(object[name] || "");
    return [name, value].join("=");
  }).join("&");
}
function throttlePromise(func) {
  return (...args) => {
    if (!func._promise_) {
      func._promise_ = func(...args);
      func._promise_.catch(() => {
      }).then(() => {
        func._promise_ = null;
      });
    }
    return func._promise_;
  };
}
async function pipelinePromise(filters, value, ...args) {
  if (!Array.isArray(filters)) {
    return value;
  }
  return await filters.reduce(async (promise, filter) => {
    const result = await promise;
    return filter(result, ...args);
  }, value);
}
var helpers = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  parseHeaders,
  parseQuery,
  stringifyQuery,
  throttlePromise,
  pipelinePromise
});
export { parseHeaders as a, helpers as h, parseQuery as p };
